import { PORT_KIND } from './ports.js'

/**
 * Event node: fires its connected actions when its single source UI object
 * emits `event`. The selectable events are resolved from the source object's
 * schema (`resolveObjectEvents`), never from a list kept here.
 */
export const eventNode = {
    kind: 'event',
    label: 'Event',
    icon: '⚡',
    color: '#d97706',
    ports: {
        inputs: [{ id: 'source', label: 'Object', accepts: [PORT_KIND.OBJECT], max: 1 }],
        outputs: [{ id: 'actions', label: 'Actions', provides: PORT_KIND.TRIGGER }],
    },
    properties: {
        // `valuesFrom: 'sourceEvents'`: options are the events of the object
        // wired to the `source` input.
        event: { type: 'enum', label: 'Event', valuesFrom: 'sourceEvents' },
    },
    defaults: { event: '' },
}
